import { buildAccountConnectionsPath, buildCorpusPath } from "../../lib/brand-navigation";
import { Navigate, useParams } from "react-router-dom";

// V2 compatibility only: keeps old nested brand aliases landing on canonical
// docs/utility routes. Do not add new product behavior here.
function resolveLegacyTarget(brandId: string, target: string) {
  if (target === "corpus") {
    return buildCorpusPath(brandId);
  }

  if (target === "settings/connections") {
    return buildAccountConnectionsPath(brandId);
  }

  if (target.startsWith("/")) {
    return target;
  }

  if (target === "" || target === "dashboard") {
    return `/brand/${brandId}/docs`;
  }

  return `/brand/${brandId}/${target}`;
}

export function BrandLegacyRedirect({ target }: { target: string }) {
  const { brandId } = useParams<{ brandId: string }>();

  if (!brandId) {
    return <Navigate to="/brand" replace />;
  }

  return <Navigate to={resolveLegacyTarget(brandId, target)} replace />;
}
